import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MadCloudCommit } from '@common/git/models/mad-cloud-commit.model';
import { PropertyObservable } from '@common/util/property-observable.decorator';
import { Project } from '@portal-core/projects/models/project.model';
import { RoutingService } from '@portal-core/routing/services/routing.service';
import { AvatarBase } from '@portal-core/ui/avatar/util/avatar.base';
import { Observable, map } from 'rxjs';

/**
 * mc-commit-avatar
 * A component for displaying a commit icon with its id.
 */
@Component({
  selector: 'mc-commit-avatar',
  templateUrl: './commit-avatar.component.html',
  styleUrls: ['./commit-avatar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommitAvatarComponent extends AvatarBase implements OnInit {
  @Input() commit: MadCloudCommit | string;
  @Input() project?: Project;
  @Input() branchName?: string;

  @PropertyObservable('commit') commit$: Observable<MadCloudCommit | string>;

  commitId$: Observable<string>;

  get routeCommands(): any[] {
    if (this.project && this.branchName) {
      const path = this.routingService.getProjectPath(this.project.LicenseId, this.project.Id, 'commits');
      const commitId = typeof this.commit === 'string' ? this.commit : (this.commit as MadCloudCommit)?.Id;
      if (typeof path === 'undefined') {
        return ['/', this.project.LicenseId, 'projects', this.project.Id, 'repository', 'commits', encodeURIComponent(this.branchName), commitId];
      } else {
        path.push(commitId);
        return path;
      }
    }
  }

  constructor(private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
    this.commitId$ = this.commit$.pipe(
      map(commit => {
        let commitId: string;

        if (typeof commit === 'string') {
          commitId = commit;
        } else if (commit) {
          commitId = commit.Id;
        }

        return commitId ? commitId.slice(0, 8) : '';
      })
    );
  }

  hasAvatarImage(): boolean {
    return true;
  }

  hasPermission(): boolean {
    return true;
  }

  isDeleted(): boolean {
    return false;
  }

  isEmpty(): boolean {
    return !this.commit;
  }

  isLink(): boolean {
    return super.isLink() && !!this.routeCommands;
  }
}

